import React from 'react'

const GenerateAsset = (props) => {
  return (
    <svg
      width="319"
      height="234"
      viewBox="0 0 319 234"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      {...props}
    >
      <rect width="319" height="234" fill="#B0E4EB" />
      <rect
        width="105.504"
        height="140.673"
        transform="matrix(4.62993e-08 -1 -1 -4.12681e-08 213.673 130.504)"
        fill="#61C9D7"
      />
      <rect
        width="105.504"
        height="140.673"
        transform="matrix(4.62993e-08 -1 -1 -4.12681e-08 204.673 138.504)"
        fill="#393E42"
      />
      <path
        d="M82.661 85.2768C81.315 85.2768 80.3003 84.9235 79.617 84.2169C78.9336 83.5324 78.5919 82.5167 78.5919 81.1697V74.3136C78.5919 73.3641 78.4366 72.6575 78.126 72.1938C77.8361 71.7301 77.3702 71.4541 76.7282 71.3657C76.4797 71.3216 76.3555 71.1781 76.3555 70.9352V68.0536C76.3555 67.7886 76.4797 67.6451 76.7282 67.623C77.3702 67.5347 77.8361 67.2587 78.126 66.795C78.4366 66.3313 78.5919 65.6357 78.5919 64.7083V57.9846C78.5919 56.6377 78.9336 55.6219 79.617 54.9374C80.3003 54.2529 81.315 53.9106 82.661 53.9106H85.4876C85.5912 53.9106 85.674 53.9548 85.7361 54.0431C85.819 54.1094 85.8604 54.1977 85.8604 54.3081V57.5209C85.8604 57.6313 85.819 57.7307 85.7361 57.819C85.674 57.8852 85.5912 57.9184 85.4876 57.9184H84.649C84.152 57.9184 83.7482 58.106 83.4376 58.4814C83.1269 58.8568 82.9716 59.3647 82.9716 60.005V65.3376C82.9716 66.4196 82.8267 67.2918 82.5368 67.9542C82.2469 68.5946 81.7913 69.0693 81.17 69.3784C81.0458 69.4447 81.0458 69.5109 81.17 69.5772C81.7913 69.9084 82.2469 70.4052 82.5368 71.0676C82.8267 71.7301 82.9716 72.6023 82.9716 73.6843V79.1493C82.9716 79.8118 83.1269 80.3196 83.4376 80.6729C83.7482 81.0483 84.152 81.236 84.649 81.236H85.4876C85.5912 81.236 85.674 81.2691 85.7361 81.3354C85.819 81.4237 85.8604 81.523 85.8604 81.6334V84.8794C85.8604 84.9898 85.819 85.0781 85.7361 85.1443C85.674 85.2327 85.5912 85.2768 85.4876 85.2768H82.661Z"
        fill="#61C9D7"
      />
      <line
        x1="99.0264"
        y1="54.4532"
        x2="158.455"
        y2="54.4533"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="99.0264"
        y1="65.0779"
        x2="128.364"
        y2="65.0779"
        stroke="#5CEBA0"
        strokeWidth="2"
      />
      <line
        x1="132.127"
        y1="65.0779"
        x2="145.668"
        y2="65.0779"
        stroke="#FCE969"
        strokeWidth="2"
      />
      <line
        x1="99.0264"
        y1="75.703"
        x2="151.684"
        y2="75.703"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="99.0264"
        y1="96.9526"
        x2="123.099"
        y2="96.9526"
        stroke="#FCE969"
        strokeWidth="2"
      />
      <line
        x1="126.862"
        y1="96.9526"
        x2="144.916"
        y2="96.9526"
        stroke="#5CEBA0"
        strokeWidth="2"
      />
      <line
        x1="99.0264"
        y1="107.577"
        x2="138.144"
        y2="107.577"
        stroke="#FD7A7D"
        strokeWidth="2"
      />
      <line
        x1="99.0264"
        y1="86.3278"
        x2="140.4"
        y2="86.3278"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="99.0264"
        y1="118.827"
        x2="126.108"
        y2="118.827"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="129.869"
        y1="118.827"
        x2="144.914"
        y2="118.827"
        stroke="#5CEBA0"
        strokeWidth="2"
      />
      <g filter="url(#filter0_d_2170_42066)">
        <path
          d="M191.433 121.395H239.144L255.048 139.606V205.166H191.433V121.395Z"
          fill="white"
        />
        <path
          d="M239.302 139.346V121.71L255.048 139.346H239.302Z"
          fill="#DFF4F7"
        />
        <line
          x1="203.4"
          y1="144.704"
          x2="242.451"
          y2="144.704"
          stroke="#B3B9BD"
          strokeWidth="2"
        />
        <line
          x1="203.4"
          y1="152.409"
          x2="242.451"
          y2="152.409"
          stroke="#B3B9BD"
          strokeWidth="2"
        />
        <line
          x1="203.4"
          y1="160.115"
          x2="242.451"
          y2="160.115"
          stroke="#B3B9BD"
          strokeWidth="2"
        />
        <line
          x1="203.4"
          y1="167.821"
          x2="242.451"
          y2="167.821"
          stroke="#B3B9BD"
          strokeWidth="2"
        />
        <line
          x1="203.4"
          y1="175.527"
          x2="242.451"
          y2="175.527"
          stroke="#B3B9BD"
          strokeWidth="2"
        />
        <line
          x1="203.4"
          y1="183.233"
          x2="242.451"
          y2="183.233"
          stroke="#B3B9BD"
          strokeWidth="2"
        />
        <line
          x1="203.4"
          y1="190.939"
          x2="242.451"
          y2="190.939"
          stroke="#B3B9BD"
          strokeWidth="2"
        />
        <path
          d="M208.3 129.139C208.916 129.139 209.458 129.265 209.924 129.517C210.391 129.769 210.75 130.129 211.002 130.595C211.264 131.053 211.394 131.58 211.394 132.177C211.394 132.765 211.259 133.283 210.988 133.731C210.727 134.179 210.354 134.529 209.868 134.781C209.392 135.024 208.842 135.145 208.216 135.145H206.228C206.182 135.145 206.158 135.169 206.158 135.215V138.785C206.158 138.832 206.14 138.874 206.102 138.911C206.074 138.939 206.037 138.953 205.99 138.953H204.352C204.306 138.953 204.264 138.939 204.226 138.911C204.198 138.874 204.184 138.832 204.184 138.785V129.307C204.184 129.261 204.198 129.223 204.226 129.195C204.264 129.158 204.306 129.139 204.352 129.139H208.3ZM208.006 133.563C208.436 133.563 208.781 133.442 209.042 133.199C209.304 132.947 209.434 132.621 209.434 132.219C209.434 131.809 209.304 131.477 209.042 131.225C208.781 130.973 208.436 130.847 208.006 130.847H206.228C206.182 130.847 206.158 130.871 206.158 130.917V133.493C206.158 133.54 206.182 133.563 206.228 133.563H208.006ZM213.476 138.953C213.429 138.953 213.387 138.939 213.35 138.911C213.322 138.874 213.308 138.832 213.308 138.785V129.321C213.308 129.275 213.322 129.237 213.35 129.209C213.387 129.172 213.429 129.153 213.476 129.153H216.976C217.676 129.153 218.287 129.279 218.81 129.531C219.342 129.774 219.753 130.119 220.042 130.567C220.331 131.015 220.476 131.533 220.476 132.121V135.985C220.476 136.573 220.331 137.091 220.042 137.539C219.753 137.987 219.342 138.337 218.81 138.589C218.287 138.832 217.676 138.953 216.976 138.953H213.476ZM215.282 137.189C215.282 137.236 215.305 137.259 215.352 137.259H217.046C217.475 137.259 217.821 137.115 218.082 136.825C218.353 136.536 218.493 136.149 218.502 135.663V132.443C218.502 131.958 218.367 131.571 218.096 131.281C217.835 130.992 217.48 130.847 217.032 130.847H215.352C215.305 130.847 215.282 130.871 215.282 130.917V137.189ZM229.452 130.679C229.452 130.726 229.434 130.768 229.396 130.805C229.368 130.833 229.331 130.847 229.284 130.847H224.706C224.66 130.847 224.636 130.871 224.636 130.917V133.087C224.636 133.134 224.66 133.157 224.706 133.157H227.716C227.763 133.157 227.8 133.176 227.828 133.213C227.866 133.241 227.884 133.279 227.884 133.325V134.683C227.884 134.73 227.866 134.772 227.828 134.809C227.8 134.837 227.763 134.851 227.716 134.851H224.706C224.66 134.851 224.636 134.875 224.636 134.921V138.785C224.636 138.832 224.618 138.874 224.58 138.911C224.552 138.939 224.515 138.953 224.468 138.953H222.83C222.784 138.953 222.742 138.939 222.704 138.911C222.676 138.874 222.662 138.832 222.662 138.785V129.321C222.662 129.275 222.676 129.237 222.704 129.209C222.742 129.172 222.784 129.153 222.83 129.153H229.284C229.331 129.153 229.368 129.172 229.396 129.209C229.434 129.237 229.452 129.275 229.452 129.321V130.679Z"
          fill="#B3B9BD"
        />
      </g>
      <circle cx="193.46" cy="168.722" r="18.6003" fill="#393E42" />
      <mask
        id="mask0_2170_42066"
        maskType="alpha"
        maskUnits="userSpaceOnUse"
        x="174"
        y="150"
        width="39"
        height="38"
      >
        <circle cx="193.46" cy="168.722" r="18.6003" fill="#ffffff" />
      </mask>
      <g mask="url(#mask0_2170_42066)">
        <line
          x1="189.358"
          y1="160.101"
          x2="237.278"
          y2="160.101"
          stroke="#5CEBA0"
          strokeWidth="4"
        />
        <line
          x1="189.358"
          y1="167.832"
          x2="237.278"
          y2="167.832"
          stroke="#5CEBA0"
          strokeWidth="4"
        />
        <line
          x1="189.358"
          y1="175.234"
          x2="237.278"
          y2="175.234"
          stroke="#5CEBA0"
          strokeWidth="4"
        />
      </g>
      <path
        d="M164.523 169.051C164.914 168.661 164.914 168.027 164.523 167.637L158.159 161.273C157.769 160.882 157.136 160.882 156.745 161.273C156.355 161.663 156.355 162.297 156.745 162.687L162.402 168.344L156.745 174.001C156.355 174.391 156.355 175.025 156.745 175.415C157.136 175.806 157.769 175.806 158.159 175.415L164.523 169.051ZM128.835 169.344H163.816V167.344H128.835V169.344ZM104.821 145.33C104.821 158.593 115.573 169.344 128.835 169.344V167.344C116.677 167.344 106.821 157.488 106.821 145.33H104.821Z"
        fill="#393E42"
      />
      <defs>
        <filter
          id="filter0_d_2170_42066"
          x="176.433"
          y="110.395"
          width="93.6152"
          height="113.771"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2170_42066"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2170_42066"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default GenerateAsset
